import React from 'react';
import logo from '../assets/lovelia-logo-transparent.png';

const Logo = ({ className = "", size = "large" }) => {
  const sizes = {
    small: { container: "h-24 w-auto", logoImg: "h-20 w-auto" },
    large: { container: "h-40 w-auto", logoImg: "h-36 w-auto" },
  };
  const currentSize = sizes[size];

  return (
    <div className={`flex flex-col items-center ${currentSize.container} ${className}`}>
      <img
        src={logo}
        alt="Lovelia — Immobilier neuf"
        className={`${currentSize.logoImg} object-contain`}
      />
    </div>
  );
};

export default Logo;
